var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewIncident(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 88,
    viewBox: "0 0 85 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.0625 39.7339V72.0654C69.0625 74.1789 68.2229 76.2058 66.7285 77.7002C65.2341 79.1946 63.2072 80.0342 61.0937 80.0342H23.9062C21.7928 80.0342 19.7659 79.1946 18.2715 77.7002C16.7771 76.2058 15.9375 74.1789 15.9375 72.0654V18.9404C15.9375 16.827 16.7771 14.8001 18.2715 13.3057C19.7659 11.8112 21.7928 10.9717 23.9062 10.9717H40.3003C41.7088 10.9719 43.0595 11.5314 44.0556 12.5272L67.5069 35.9786C68.5027 36.9747 69.0623 38.3254 69.0625 39.7339Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5 12.2998V32.2217C42.5 33.6306 43.0597 34.9819 44.056 35.9782C45.0523 36.9745 46.4035 37.5342 47.8125 37.5342H67.7344",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2188 50.8149H55.7812",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2188 64.0972H55.7812",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5 3.28052C53.6599 3.28052 47.2812 9.65913 47.2812 17.4993C47.2812 25.3394 53.6599 31.718 61.5 31.718C69.3401 31.718 75.7187 25.3394 75.7187 17.4993C75.7187 9.65913 69.3401 3.28052 61.5 3.28052ZM61.5 25.1494C61.2296 25.1494 60.9653 25.0692 60.7404 24.919C60.5156 24.7687 60.3404 24.5552 60.2369 24.3054C60.1334 24.0556 60.1063 23.7807 60.1591 23.5154C60.2118 23.2502 60.342 23.0066 60.5333 22.8154C60.7245 22.6242 60.9681 22.494 61.2333 22.4413C61.4985 22.3885 61.7734 22.4156 62.0232 22.5191C62.273 22.6225 62.4865 22.7978 62.6368 23.0226C62.787 23.2474 62.8672 23.5118 62.8672 23.7822C62.8672 24.1448 62.7231 24.4925 62.4667 24.7489C62.2104 25.0053 61.8626 25.1494 61.5 25.1494ZM62.9848 11.3989L62.5924 19.7387C62.5924 20.0288 62.4771 20.307 62.272 20.5121C62.0669 20.7172 61.7887 20.8325 61.4986 20.8325C61.2086 20.8325 60.9304 20.7172 60.7252 20.5121C60.5201 20.307 60.4049 20.0288 60.4049 19.7387L60.0125 11.403V11.3996C60.0039 11.1992 60.0359 10.9992 60.1067 10.8116C60.1774 10.6239 60.2854 10.4526 60.4241 10.3078C60.5628 10.1629 60.7294 10.0477 60.9139 9.969C61.0983 9.89028 61.2967 9.84969 61.4973 9.84969C61.6978 9.84969 61.8962 9.89028 62.0807 9.969C62.2651 10.0477 62.4317 10.1629 62.5704 10.3078C62.7091 10.4526 62.8171 10.6239 62.8879 10.8116C62.9586 10.9992 62.9906 11.1992 62.982 11.3996L62.9848 11.3989Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewIncident);
export default __webpack_public_path__ + "static/media/new-incident.8a1f3e93390977969cdc6313ee3c3590.svg";
export { ForwardRef as ReactComponent };